<template>
  <div>
    <div class="topbar" v-show="!isShowComment">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)" >返回</a>
        <h1 v-if="dynamicTypeId == 0">园点动态</h1>
        <h1 v-if="dynamicTypeId == 1">伙食</h1>
        <h1 v-if="dynamicTypeId == 2">孩子动态</h1>
        <router-link class="pull-right icon-right icon-setup text-hide" :to="{'path' : '/dynamic/publish/' + dynamicTypeId}">发起</router-link>
      </div>
      <div class="liner"></div>
    </div>

    <mt-loadmore :top-method="loadTop" v-show="!isShowComment" ref="loadmore">
    <div class="main-page bg-white"  
    v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150">
      <div class="dynamic" @click="hideTips()">
          <div v-for="(item, index) in dynamicList">
          <div class="padding-15 clearfix">
            <div class="pull-left left-part"><div class="img-wrap small"><img :src="item.teacher_icon ? item.baseAcessPath + item.teacher_icon : img_default"  class="mid-align" /></div></div>
            <div class="right-part">
              <span class="font-16" style="color:#449;">{{item.teacherName}}</span>
              <p>{{item.content}}</p>
              <ul class="block clearfix imgs">
                <li class="col-xs-4" v-for="(img, index) in item.imageList">
                  <div class="t-r-5">
                  <div class="out-wrap"><span @click="showImgList(item.imageList, index)">
                    <!-- <img :data-original="img.baseAcessPath + img.thumbAddress" v-if="img.thumbAddress"/>
                    <img :src="img.baseAcessPath + img.thumbAddress" v-else/> -->
                    <img :src="img.baseAcessPath + img.thumbAddress" class="mid-align" />
                  </span></div></div>
                </li>
              </ul>
              <div class="clearfix">
                <cite class="gray pull-left font-12">{{item.publishDate | dateDiff}}</cite>
                <span class="pull-left margin-x-15 font-12" v-if="item.teacherId == teacherId" @click="delDynamicId = item.dynamicId, delDynamicIndex = index, isHideDelDynamic = false">删除</span>
                <span class="pull-right icon-p-c" @click.stop="showTips(item)">更多</span>
                <div class="tips-comwrap">
                  <div class="tip-comment" v-show="item.isShowTips">
                    <div class="col-xs-6" v-if="item.isDz"><span class="icon-praise" @click="nowDzList = item.dzList, nowDynamic = item, cancelDzDynamic()">取消</span></div>
                    <div class="col-xs-6" v-else><span class="icon-praise" @click="nowDynamic = item, dzDynamic()">点赞</span></div>
                    <div class="col-xs-6"><span class="icon-comment" @click="showCommentDialog(item)">评论</span></div>
                  </div>
                </div>
              </div>

              <div class="comment" v-if="item.dzList.length > 0 || item.commentList.length > 0">
                <div class="icon-praise praiser" v-if="item.dzList.length > 0">
                <span v-for="(dz, index) in item.dzList" v-if="dz.type == '0'">
                  {{dz.commentName ? dz.commentName : dz.parent_name}} {{index == item.dzList.length - 1 ? '' : '、'}}
                </span>
                </div>
                <div class="liner" v-show="item.dzList.length > 0 && item.commentList.length > 0"></div>
                <ul class="con-comment" v-if="item.commentList.length > 0">
                  <li class="clearfix" v-for="(pl, index) in item.commentList" v-if="pl.type == '1'" @click="showDelComment(pl, item, index)">
                    <span>{{pl.commentName ? pl.commentName : pl.parent_name}}:</span>
                    {{pl.content}}
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="liner"></div>
          </div>
          <!-- <p v-show="isGetting" class="page-infinite-loading">
            <mt-spinner type="fading-circle"></mt-spinner>
            加载中...
          </p> -->
      </div>
    </div>
    
    </mt-loadmore>

    <div class="main-page" v-show="isShowComment">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="hideComment()">返回</a>
          <h1></h1>
          <span class="pull-right icon-right orange" @click="commentDynamic()">发送</span>
        </div>
        <div class="liner"></div>
      </div>

      <div class="padding-15 bg-white">
        <textarea class="font-14" width="100%" rows="5" placeholder="这一刻的想法..." v-model="content"></textarea>
      </div>
    </div>
    <!-- <div>
      <router-view></router-view>
    </div> -->

    <!-- 删除动态 -->
    <div class="maskdiv" v-show="!isHideDelDynamic" @click="isHideDelDynamic = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p class="margin-15">确认要删除这条动态吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
              <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deleteDynamic()">删除</a></div>
              <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideDelDynamic = true">不删除</a></div>
            </div>
        </div>
      </div>
    </div>

    <!-- 删除评论 -->
    <div class="maskdiv" v-show="!isHideDelComment" @click="isHideDelComment = true">
      <div class="bottom-block text-center" style="background:none" @click.stop>
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="deleteDynamicComment()"><span class="orange block font-16">删除</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="isHideDelComment = true"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
    </div>

    <div class="maskdiv" @click="isShowImgs = false" v-if="isShowImgs" style="background:rgba(0,0,0,1)">
    <div class="imgs-box" >
      <div class="swiper-container" >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in imageList" style="height:100vh">
            <img :data-src="item.baseAcessPath + item.imageAddress" class="swiper-lazy bigger-pic hide" :thumbImg="item.baseAcessPath + item.thumbAddress">
            <!-- <img :data-src="item.baseAcessPath + item.thumbAddress" class="swiper-lazy"/> -->
            <!-- <div class="swiper-lazy-preloader" style="width:100%"><img :src="item.baseAcessPath + item.thumbAddress" style="position:fixed"></div> -->
            <!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-white" style="position:fixed"></div> -->
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    dynamicFood: 'dynamicFood',
    dynamicCurche: 'dynamicCurche'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      dynamicTypeId: 0,
      curcheId: 0,
      teacherId: 0,
      isGetting: true, // 是否正在获取数据中
      isOver: false, // 是否是没有数据获取了
      get_dynamic_info_para: service.setPara('getDynamicInfo'),
      comment_dynamic_para: service.setPara('commentDynamic'),
      dz_dynamic_para: service.setPara('dzDynamic'),
      delete_dynamic_para: service.setPara('deleteDynamic'),
      delete_dynamic_comment_para: service.setPara('deleteDynamicComment'),
      dynamicList: [],
      refreshDate: '',
      showTipIndex: -1,
      nowDynamic: {},
      dzIndex: -1,
      commentIndex: -1,
      isShowComment: false,
      nowCommentList: [],
      nowCommentId: 0,
      isHideDelDynamic: true,
      isHideDelComment: true,
      // 删除动态
      delDynamicId: 0,
      delDynamicIndex: 0,
      // 取消点赞
      nowDzList: [],
      isLock: true,
      imageList: [],
      isShowImgs: false,
      content: '',
      dynamicNew: {},
      isUploadOver: true,
      scrollTop: 0,
      localStorage_refreshDate: 0,
      mySwiper: {},
      hideCommentScrollTop: 0
    }
  },
  mounted: function () {
    this.dynamicTypeId = this.$route.params.dynamicTypeId
    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId

    // 获取缓存数据
    var that = this
    let obj = this.dynamicTypeId == 0 ? this.dynamicCurche : this.dynamicFood
    let flag = true
    if (obj) {
      if ((new Date().getTime() - obj.refreshDate) < 300 * 1000 && obj.para.curcheId == this.curcheId) { // 5分钟刷一下
        let jsonStr = JSON.stringify(obj.dynamicList)
        this.dynamicList = JSON.parse(jsonStr)
        this.get_dynamic_info_para = obj.para
        this.isOver = obj.isOver
        this.localStorage_refreshDate = obj.refreshDate
        flag = false
        that.$nextTick(function () {
          that.isGetting = false
          // $('.hotactives img').lazyload()
          document.body.scrollTop = obj.scrollTop
        })
      }
    }
    if (flag) {
      this.get_dynamic_info_para.dynamicType = this.dynamicTypeId
      this.get_dynamic_info_para.offset = 0
      this.get_dynamic_info_para.curcheId = this.curcheId
      window.localStorage.removeItem('dynamicList_' + this.dynamicTypeId)
      this.getDynamicList()
    }

    // this.getDynamicList()
    // this.isScrollBottom()
  },
  methods: {
    ...mapMutations([
      'receiveDynamic'
    ]),
    loadTop (id) {
      this.get_dynamic_info_para.offset = 0
      this.isOver = false
      this.dynamicList = []
      this.getDynamicList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    loadBottom () {
      if (this.isOver || this.isGetting) {
        return
      }
      this.get_dynamic_info_para.offset++
      this.get_dynamic_info_para.refreshDate = this.refreshDate
      this.getDynamicList()
    },
    getDynamicList: function () { // 获取动态列表
      this.isGetting = true

      let that = this
      let obj = {context: this, para: this.get_dynamic_info_para, isIndicator: false, successFun: (response) => {
        if (response.data.list.length == 0) {
          that.isOver = true
        } else {
          that.refreshDate = response.data.refreshDate
          var list = response.data.list
          for (var i = 0; i < list.length; i++) {
            list[i].isDz = false
            list[i].isShowTips = false
            for (var j = 0; j < list[i].dzList.length; j++) {
              if (list[i].dzList[j].commentUserid == that.teacherId) {
                list[i].isDz = true
              }
            }
          }
          that.dynamicList = that.dynamicList.concat(list)
          that.$nextTick(function () {
            that.isGetting = false
          })
        }
      }}
      service.request(obj)
    },
    commentDynamic: function () { // 评论
      if ($.trim(this.content) == '') {
        Toast('评论不能为空')
        return
      }
      this.comment_dynamic_para.dynamicId = this.nowDynamic.dynamicId
      this.comment_dynamic_para.userId = this.teacherId
      this.comment_dynamic_para.content = $.trim(this.content)

      let that = this
      let obj = {context: this, para: this.comment_dynamic_para, successFun: (response) => {
        that.content = ''
        that.isShowComment = false
        // Toast('评论成功')
        that.nowDynamic.commentList.unshift(response.data)
        Vue.nextTick(function () {
          document.body.scrollTop = that.hideCommentScrollTop
        })
      }}
      service.request(obj)
    },
    hideComment: function () { // 隐藏评论
      this.isShowComment = false
      this.$nextTick(function () {
        document.body.scrollTop = this.hideCommentScrollTop
      })
    },
    dzDynamic: function () { // 点赞
      this.dz_dynamic_para.dynamicId = this.nowDynamic.dynamicId
      this.dz_dynamic_para.userId = this.teacherId

      let that = this
      let obj = {context: this, para: this.dz_dynamic_para, successFun: (response) => {
        that.nowDynamic.isDz = true
        that.nowDynamic.dzList = response.data.dzUserNames
      }}
      service.request(obj)
    },
    cancelDzDynamic: function () { // 取消点赞
      var dzId = -1
      var index = -1
      for (var z = 0; z < this.nowDzList.length; z++) {
        if (this.nowDzList[z].commentUserid == this.teacherId) {
          dzId = this.nowDzList[z].commentId
          index = z
          break
        }
      }
      this.delete_dynamic_comment_para.commentId = dzId

      let that = this
      let obj = {context: this, para: this.delete_dynamic_comment_para, successFun: (response) => {
        Toast('取消成功')
        that.nowDynamic.isDz = false
        that.nowDzList.splice(index, 1)
      }}
      service.request(obj)
    },
    deleteDynamic: function () { // 删除动态
      this.delete_dynamic_para.dynamicId = this.delDynamicId

      let obj = {context: this, para: this.delete_dynamic_para, successFun: (response) => {
        Toast('删除成功')
        this.isHideDelDynamic = true
        this.dynamicList.splice(this.delDynamicIndex, 1)
      }}
      service.request(obj)
    },
    deleteDynamicComment: function () { // 删除评论
      this.delete_dynamic_comment_para.commentId = this.nowCommentId

      let obj = {context: this, para: this.delete_dynamic_comment_para, successFun: (response) => {
        Toast('删除成功')
        this.isHideDelComment = true
        this.nowCommentList.splice(this.commentIndex, 1)
      }}
      service.request(obj)
    },
    showImgList: function (imgs, index) {
      if (this.mySwiper.destroy) {
        this.mySwiper.destroy(false, true)
      }
      var that = this
      this.isShowImgs = true
      this.imageList = imgs
      this.$nextTick(function () {
        that.mySwiper = new Swiper('.swiper-container', {
          // loop: true,
          // 如果需要分页器
          pagination: '.swiper-pagination',
          autoplayDisableOnInteraction: false,
          lazyLoading: true,
          autoHeight: true,
          initialSlide: index,
          onLazyImageLoad: function (swiper, slide, image) {
            // alert('延迟加载图片完成')
            // console.log(slide) // 哪个slide里面的图片在加载
            $(image).before('<img class="swiper-lazy swiper-lazy-loaded " src="' + $(image).attr('thumbimg') + '">')
            $(image).before('<div class="swiper-lazy-preloader swiper-lazy-preloader-white" style="position:fixed"></div>')
            // console.log(image) // 哪个图片在加载
          },
          onLazyImageReady: function (swiper, slide, image) {
            // alert('延迟加载图片完成')
            // console.log(swiper) // Swiper实例
            // console.log(slide) // 哪个slide里面的图片在加载
            // console.log(image) // 哪个图片在加载
            $(image).prev('img').remove()
            $(image).removeClass('hide')
            $(image).addClass('thispic')
            // $(image).removeClass('thispic')
          },
          onSlideChangeEnd: function (swiper) {
            $('.swiper-slide').not('.swiper-slide-active').children('.bigger-pic').removeClass('thispic')
          }
        })
        $('.swiper-lazy-preloader-white').css('top', '50%')
      })
    },
    showCommentDialog: function (item) {
      this.hideCommentScrollTop = document.body.scrollTop
      this.isShowComment = true
      this.nowDynamic = item
      /* this.$nextTick(function () {
        $('#content').focus()
      }) */
    },
    showDelComment: function (pl, item, index) { // 显示删除评论
      if (pl.commentUserid != this.teacherId) {
        return
      }
      this.isHideDelComment = false
      this.nowCommentId = pl.commentId
      this.nowCommentList = item.commentList
      this.commentIndex = index
    },
    hideTips: function () { // 隐藏所有的右边..弹出框
      for (var i = 0; i < this.dynamicList.length; i++) {
        this.dynamicList[i].isShowTips = false
      }
    },
    showTips: function (item) {
      for (var i = 0; i < this.dynamicList.length; i++) {
        if (this.dynamicList[i].dynamicId == item.dynamicId) {
          this.dynamicList[i].isShowTips = !this.dynamicList[i].isShowTips
        } else {
          this.dynamicList[i].isShowTips = false
        }
      }
    }
  },
  beforeDestroy: function () {
    if (this.mySwiper.destroy) {
      this.mySwiper.destroy(false, true)
    }

    // if (this.dynamicList.length > 0) {
      // 保存缓存数据
    let obj = {}
    obj.scrollTop = this.scrollTop
    obj.dynamicList = this.dynamicList
    obj.para = this.get_dynamic_info_para
    obj.isOver = this.isOver
    obj.refreshDate = this.localStorage_refreshDate || new Date().getTime()
    this.$store.dispatch('receiveDynamic', obj)
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:39px;}
  .swiper-slide{height:100vh;}
</style>


// WEBPACK FOOTER //
// DynamicList.vue?7ce337f2